import type { ErrorEvent, EventHint } from '@sentry/react';

import {
  isDescopeConsoleEvent,
  isDescopeRecaptchaRemoveEvent,
} from './descope-sentry-event';
import { getAxiosSentryContext } from './get-axios-sentry-context';
import { isClientHttpError } from './is-client-http-error';

export function processSentryBeforeSendEvent(
  event: ErrorEvent,
  hint?: EventHint,
): ErrorEvent | null {
  const originalException = hint?.originalException;
  const syntheticException = hint?.syntheticException;

  if (
    isClientHttpError(originalException) ||
    isClientHttpError(syntheticException)
  ) {
    return null;
  }

  const statusCode =
    (event as any)?.contexts?.response?.status_code ??
    (event as any)?.request?.status_code;
  if (typeof statusCode === 'number' && statusCode >= 400 && statusCode < 500) {
    return null;
  }

  const message =
    event.message ||
    (event.exception?.values && event.exception.values[0]?.value);
  if (typeof message === 'string') {
    const axiosStatusMatch = message.match(
      /Request failed with status code (\d{3})/,
    );
    if (axiosStatusMatch) {
      const status = Number(axiosStatusMatch[1]);
      if (status >= 400 && status < 500) {
        return null;
      }
    }
  }

  if (isDescopeConsoleEvent(event)) {
    return null;
  }

  if (isDescopeRecaptchaRemoveEvent(event, hint)) {
    return null;
  }

  const axiosContext = getAxiosSentryContext(originalException);
  if (axiosContext) {
    event.fingerprint = axiosContext.fingerprint;
    event.tags = {
      ...event.tags,
      ...axiosContext.tags,
    };
  }

  return event;
}
